import { ROUTES } from '@consts/routes';
import { useStyles } from './styles/MainBarHeader.styles';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { FlatRoute } from './FlatRoute';
import { SegmentRoute } from './SegmentRoute';
import { checkPathHasPermission } from '@utils/permissions';

import type { RootState } from '@features/redux/store';

export const MainBarHeader = ({ mobile, onClick }: { mobile: boolean; onClick?: () => void }) => {
    const classes = useStyles();

    const role = useSelector((state: RootState) => state.auth.Roles.role);

    const availableSegments = useMemo(
        () => ROUTES.filter((segment) => segment.routes.some((route) => checkPathHasPermission(role, route.link))),
        [role]
    );

    return (
        <ul className={mobile ? classes.headerMenuMobile : classes.headerMenu}>
            {availableSegments.flatMap((segment) =>
                mobile || segment.routes.length <= 1 ? (
                    segment.routes.map((route) => (
                        <FlatRoute key={route.link} route={route} mobile={mobile} onClick={onClick} />
                    ))
                ) : (
                    <SegmentRoute key={segment.name} segment={segment} />
                )
            )}
        </ul>
    );
};
